import { RATING_LABEL } from '@pti/domain';

/** A rating 1–5 as a coloured chip (Outstanding … Not meeting). */
export function RatingChip({ r, muted, label }: { r: number | null | undefined; muted?: boolean; label?: boolean }) {
  if (!r) return <span className="dim">—</span>;
  return <span className="rchip-wrap"><span className={`rchip r${r}${muted ? ' muted' : ''}`} title={RATING_LABEL[r]}>{r}</span>{label && <span className="small">{RATING_LABEL[r]}</span>}</span>;
}

/** Pick a rating 1–5. Ratings above `cap` can't be chosen. */
export function RatingPicker({ value, onChange, cap = 5, disabled, label }: { value: number | null | undefined; onChange: (r: number) => void; cap?: number; disabled?: boolean; label: string }) {
  return (
    <div className="rpick" role="radiogroup" aria-label={label}>
      {[1, 2, 3, 4, 5].map((r) => (
        <button key={r} type="button" role="radio" aria-checked={value === r} disabled={disabled || r > cap} title={r > cap ? 'Above the cap' : RATING_LABEL[r]}
          className={`rp r${r}${value === r ? ' on' : ''}${r > cap ? ' capped' : ''}`} onClick={() => onChange(r)}>{r}</button>
      ))}
    </div>
  );
}

/** Where pay sits in its band: −8% to 108% with the band zones. */
export function BandMeter({ pos, after }: { pos: number; after?: number | null }) {
  const x = (v: number) => `calc(${((Math.max(-0.08, Math.min(1.08, v)) + 0.08) / 1.16) * 100}% - 5px)`;
  return (
    <div className="meter" aria-hidden="true">
      <div className="meter-track">
        {after != null && after !== pos && <span className="meter-dot ghost" style={{ left: x(after) }} />}
        <span className={`meter-dot${pos < 0 || pos > 1 ? ' out' : ''}`} style={{ left: x(pos) }} />
      </div>
    </div>
  );
}
